import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Bookmark, X } from 'lucide-react';

const STORAGE_KEY = 'menu-favorites-onboarding-seen';

type Props = {
  /** Светлая тема (меню зала) */
  light?: boolean;
  className?: string;
};

export function MenuFavoritesOnboarding({ light = false, className = '' }: Props) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) === '1') return;
    } catch {
      /* show anyway */
    }
    setVisible(true);
  }, []);

  function dismiss() {
    setVisible(false);
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* ignore */
    }
  }

  const bg = light ? '#0a0a0a' : '#fff';
  const fg = light ? '#fff' : '#0a0a0a';
  const muted = light ? 'rgba(255,255,255,0.65)' : 'rgba(10,10,10,0.55)';

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
          className={`relative mb-6 rounded-2xl px-4 py-3.5 ${className}`}
          style={{ background: bg, color: fg }}
          role="status"
        >
          <div className="flex items-start gap-3">
            <div
              className="mt-0.5 w-8 h-8 rounded-full flex items-center justify-center shrink-0"
              style={{ background: light ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.06)' }}
            >
              <Bookmark size={15} fill={fg} style={{ color: fg }} />
            </div>
            <div className="min-w-0 flex-1 pr-6">
              <p
                className="text-[14px] font-semibold leading-snug"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                Отмечайте блюда закладкой
              </p>
              <p
                className="text-[12px] mt-1 leading-relaxed"
                style={{ color: muted, fontFamily: 'Manrope, sans-serif' }}
              >
                Сохраняйте любимое и то, что хотите заказать — список не потеряется.
              </p>
            </div>
            <button
              type="button"
              onClick={dismiss}
              className="absolute top-2.5 right-2.5 w-8 h-8 flex items-center justify-center active:opacity-60"
              aria-label="Закрыть"
              style={{ color: muted }}
            >
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
